import { useMutation, useQueryClient } from "react-query";
import { useUser } from "@/providers/context";
import { AxiosError } from "axios";
import { deleteWatchlistItem, UpdateDefaultPlaylist } from "@/api";

export const useDeleteWatchlistItem = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    Omit<UpdateDefaultPlaylist, "UserId">
  >(
    async (watchlistItem) => {
      if (uid) {
        return await deleteWatchlistItem({ ...watchlistItem, UserId: uid });
      }
    },
    {
      onSuccess: (data) => {
        // Update the local watchlist immediately with the response
        if (data) {
          queryClient.setQueryData(["watchlist", uid], data);
        }
      },
    },
  );
};
